import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const Voltages = (props: Props) => (
  <FilterAutocomplete
    label="Voltages"
    fieldName={'voltages'}
    fieldPath={'productInformation.voltages'}
  />
)
